/* Elya — Klaviyo "Added to Cart" tracking.
   Intercepte les ajouts panier (fetch + XHR vers /cart/add), puis lit /cart.js
   et pousse l'événement Klaviyo avec le contenu du panier.
   Fonctionne avec tous les boutons (fiche produit, bundle, quick-add).
   Multi-devise (EUR/CHF/CAD) + multi-langue (6 locales) : la devise vient de
   /cart.js (devise de présentation), la locale/pays des globales Shopify. */
(function () {
  var klaviyo = window.klaviyo = window.klaviyo || [];
  var lastSent = 0;

  // Produit "Assurance livraison" : ajouté via /cart/add.js par wl-insurance.js.
  // Cocher la case ne doit PAS émettre un "Added to Cart".
  var INSURANCE_VARIANT_ID = '49868465799408';

  // Locales de la boutique (repli si Shopify.routes.root est indisponible).
  var LOCALES = ['fr', 'en', 'de', 'es', 'it', 'nl'];

  /* ---------- locale / marché ---------- */

  // Racine de la locale courante : "/" (langue par défaut du domaine) ou "/de/", "/nl/"...
  // Shopify.routes.root est la source officielle et est injectée par Shopify sur
  // chaque page ; repli sur le 1er segment du chemin s'il correspond à une locale.
  function localeRoot() {
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (r && String(r).charAt(0) === '/') {
        r = String(r);
        return r.charAt(r.length - 1) === '/' ? r : r + '/';
      }
    } catch (e) {}
    try {
      var seg = String(window.location.pathname).split('/')[1];
      if (LOCALES.indexOf(seg) !== -1) return '/' + seg + '/';
    } catch (e2) {}
    return '/';
  }

  function currentLocale() {
    try {
      if (window.Shopify && window.Shopify.locale) return String(window.Shopify.locale);
    } catch (e) {}
    try {
      if (document.documentElement && document.documentElement.lang) {
        return String(document.documentElement.lang);
      }
    } catch (e2) {}
    return '';
  }

  function currentCountry() {
    try {
      if (window.Shopify && window.Shopify.country) return String(window.Shopify.country);
    } catch (e) {}
    return '';
  }

  // Absolutise une URL de /cart.js ("/products/x?variant=1") en la préfixant de la
  // racine de locale — /cart.js ne préfixe jamais la locale.
  function absoluteUrl(path) {
    var root = localeRoot();
    var p = String(path || '');
    if (!p) return window.location.origin + root;
    if (p.charAt(0) !== '/') p = '/' + p;
    // déjà préfixé (sécurité) -> ne pas doubler
    if (root !== '/' && (p === root.slice(0, -1) || p.indexOf(root) === 0)) {
      return window.location.origin + p;
    }
    return window.location.origin + root + p.slice(1);
  }

  /* ---------- garde assurance-livraison ---------- */

  // Ids de variante considérés comme "assurance" : l'id connu + ceux exposés dans le
  // DOM par wl-insurance.js (data-wl-insurance-vid) -> reste juste si l'id change.
  function insuranceIds() {
    var ids = [INSURANCE_VARIANT_ID];
    try {
      var nodes = document.querySelectorAll('[data-wl-insurance-vid]');
      Array.prototype.forEach.call(nodes, function (n) {
        var v = n.getAttribute('data-wl-insurance-vid');
        if (v && ids.indexOf(String(v)) === -1) ids.push(String(v));
      });
    } catch (e) {}
    return ids;
  }

  // Ids de variante ajoutés par une requête /cart/add — null si indéterminable.
  function addedIds(body) {
    try {
      if (body == null) return null;
      if (typeof body === 'string') {
        var s = body.trim();
        if (s.charAt(0) === '{') {
          var j = JSON.parse(s);
          if (j && j.items && j.items.length) {
            return j.items.map(function (i) { return String(i && i.id); });
          }
          if (j && j.id != null) return [String(j.id)];
          return null;
        }
        var q = new URLSearchParams(s).getAll('id');
        return q.length ? q.map(String) : null;
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var f = body.getAll('id');
        return f.length ? f.map(String) : null;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var u = body.getAll('id');
        return u.length ? u.map(String) : null;
      }
    } catch (e) {}
    return null; // inconnu -> on laisse passer (ne jamais casser le tracking normal)
  }

  // true seulement si l'ajout ne contient QUE de l'assurance.
  function isInsuranceOnly(ids) {
    if (!ids || !ids.length) return false;
    var ins = insuranceIds();
    for (var i = 0; i < ids.length; i++) {
      if (ins.indexOf(String(ids[i])) === -1) return false;
    }
    return true;
  }

  /* ---------- event ---------- */

  function sendAtc() {
    var now = Date.now();
    if (now - lastSent < 1500) return; // anti-doublon (bundle = plusieurs adds)
    lastSent = now;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var items = cart.items.map(function (it) {
          return {
            Name: it.product_title,
            Variant: it.variant_title || '',
            Price: (it.price / 100).toFixed(2),
            Quantity: it.quantity,
            ImageURL: it.image || '',
            URL: absoluteUrl(it.url)
          };
        });
        var currency = cart.currency || '';
        if (!currency) {
          try { currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''; } catch (e) {}
        }
        var payload = {
          // /cart.js renvoie les prix en centimes de la devise de PRÉSENTATION
          // (EUR/CHF/CAD) -> $value et $currency sont cohérents entre eux.
          '$value': (cart.total_price / 100).toFixed(2),
          '$currency': currency,
          'ItemCount': cart.item_count,
          'Items': items,
          'CartURL': absoluteUrl('/cart'),
          'Locale': currentLocale(),
          'Country': currentCountry()
        };
        klaviyo.push(['track', 'Added to Cart', payload]);
      })
      .catch(function () {});
  }

  function isCartAdd(url) {
    try { return String(url).indexOf('/cart/add') !== -1; } catch (e) { return false; }
  }

  // fetch
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var p = origFetch.apply(this, args);
    try {
      var u = args[0] && args[0].url ? args[0].url : args[0];
      if (isCartAdd(u)) {
        var init = args[1];
        var ids = addedIds(init && init.body != null ? init.body : null);
        if (!isInsuranceOnly(ids)) {
          p.then(function (r) { if (r && r.ok) sendAtc(); }).catch(function () {});
        }
      }
    } catch (e) {}
    return p;
  };

  // XHR (au cas où)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__wlCartAdd = isCartAdd(url); } catch (e) {}
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    var self = this;
    try {
      if (self.__wlCartAdd) {
        var ids = addedIds(body);
        if (!isInsuranceOnly(ids)) {
          self.addEventListener('load', function () {
            if (self.status >= 200 && self.status < 300) sendAtc();
          });
        }
      }
    } catch (e) {}
    return origSend.apply(this, arguments);
  };

  // formulaires classiques action="/cart/add"
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && isCartAdd(f.action)) {
      var ids = null;
      try { ids = addedIds(new FormData(f)); } catch (e2) {}
      if (!isInsuranceOnly(ids)) setTimeout(sendAtc, 1200);
    }
  }, true);
})();
